<nav class="navbar navbar-inverse navbar-toggleable-sm mb-5">
  <div class="container">
    <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarCollapse">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:
true}">{{ 'MY_STORYBOARDS' | translate }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/templates" routerLinkActive="active">{{ 'MY_TEMPLATES' | translate }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/help" routerLinkActive="active">{{ 'HELP' | translate }}</a>
        </li>
        <li class="nav-item" *ngIf="authService.hasRole('administrator') || authService.hasRole('editor')">
          <a class="nav-link" routerLink="/admin/dashboard" routerLinkActive="active">{{ 'MANAGEMENT' | translate }}</a>
        </li>
      </ul>

    </div>
  </div>
</nav>


// WEBPACK FOOTER //
// ./src/app/navigation/navigation.component.html